import {
    firebaseGet,
    firebasePost,
    firebasePut,
    firebaseDel
} from '../configApi'

//quiz
export async function getListPoll(params) {
    return await firebaseGet(`/votePoll-getPoll`, params)
}
export async function insertPoll(body) {
    return await firebasePost(`/votePoll-insertPoll`, body)
}
export async function insertChoice(body) {
    return await firebasePost(`/votePoll-insertChoice`, body)
}
export async function votePoll(body) {
    return await firebasePost(`/votePoll-vote`, body)
}
export async function updatePoll(body) {
    return await firebasePut(`/votePoll-updatePoll`, body)
}
export async function deletePoll(body) {
    return await firebaseDel(`/votePoll-deletePoll`, body)
}
export async function deleteChoice(body) {
    return await firebaseDel(`/votePoll-deleteChoice`, body)
}